import React from "react";
import StarRatingComponent from "react-star-rating-component";
import moment from "moment";
import { getLabelRate } from "../../../utils/Utils";

interface AvisTableProps {
  avis: any[];
  isLoading?: boolean;
}

const AvisTable: React.FC<AvisTableProps> = ({ avis = [], isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="avis-table-skeleton">
        {[1, 2, 3].map((i) => (
          <div key={i} className="avis-table-skeleton-row" />
        ))}
      </div>
    );
  }

  if (!avis.length) {
    return (
      <div className="avis-table-empty">
        <p>Aucun avis pour ce produit.</p>
      </div>
    );
  }

  return (
    <div className="avis-table-wrapper">
      <table className="avis-table">
        <thead>
          <tr>
            <th className="avis-th">AUTEUR</th>
            <th className="avis-th">NOTE</th>
            <th className="avis-th">MOTIF</th>
            <th className="avis-th">COMMENTAIRE</th>
          </tr>
        </thead>
        <tbody>
          {avis.map((item, i) => (
            <tr key={i} className="avis-tr">
              <td className="avis-td">
                <p className="avis-author-name">
                  {item?.annonyme
                    ? "Anonyme"
                    : `${item?.auteur?.prenom} ${item?.auteur?.nom}`}
                </p>
                <p className="avis-date">
                  {moment(item?.created_at).format("DD MMMM YYYY")}
                </p>
              </td>
              <td className="avis-td">
                <p className="avis-note">{item?.note}/5</p>
                <StarRatingComponent
                  name={`rate-${i}`}
                  starCount={5}
                  value={item?.note}
                  starColor="#DDB012"
                  emptyStarColor="#D4D6D5"
                />
              </td>
              <td className="avis-td">
                <p className="avis-motif">{item?.motif || "—"}</p>
                <p className="avis-date">
                  du {moment(item?.created_at).format("DD MMMM YYYY")}
                </p>
              </td>
              <td className="avis-td">
                <p className="avis-label">{getLabelRate(item?.note)}</p>
                <p className="avis-comment">{item?.commentaire || "—"}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AvisTable;